export default class RequestData {
    private readonly requestData: any;
    private requestDate: Date;
    private responseDate: Date;
    private responseTimeInMs: number;
    private responseData: JSON;
    private retryCount: number;
    private errorMessage: string;

    constructor(requestData: any) {
        this.requestData = requestData;
        this.requestDate = new Date();
    }

    onResponse(response: JSON, retryCount: number, errorMessage: string): void {
        this.responseData = response;
        this.responseDate = new Date();
        this.responseTimeInMs = this.timeSpan(
            this.requestDate,
            this.responseDate
        );
        this.retryCount = retryCount;
        this.errorMessage = errorMessage;
    }

    /**
     * Gets the timespan in milliseconds by subracting second and first (seconds - first).
     *
     * @param {Date} first
     * @param {Date} second
     * @return {*}  {number}
     * @memberof Utils
     */
    private timeSpan(first: Date, second: Date): number {
        if (first instanceof String) {
            first = new Date(first);
        }

        if (second instanceof String) {
            second = new Date(second);
        }

        const utcDate = Date.UTC(
            second.getFullYear(),
            second.getMonth(),
            second.getDate(),
            second.getHours(),
            second.getMinutes(),
            second.getSeconds(),
            second.getMilliseconds()
        );
        const utcOther = Date.UTC(
            first.getFullYear(),
            first.getMonth(),
            first.getDate(),
            first.getHours(),
            first.getMinutes(),
            first.getSeconds(),
            first.getMilliseconds()
        );

        return utcDate - utcOther;
    }
}
